module.exports = __webpack_public_path__ + "img/mwm_modernworldt.0740dac.png";